import React, {useEffect, useState} from 'react';
import {Divider, Stack, Box} from '@mui/material';
import {useChatContext} from '../context';
import ChatListItem from './ChatListItem';
import {ChatListSearch} from './ChatListSearch';
import {GroupChatCreateModal} from './GroupChatCreateModal';
import {useDeviceInfo} from 'utils/hooks/useDeviceInfo';

export const ChatList = () => {
    const {chats, selectedChat} = useChatContext();
    const {isMobile} = useDeviceInfo();

    const [viewList, setViewList] = useState(true);

    useEffect(() => {
        if (selectedChat) {
            setViewList(false);
        } else {
            setViewList(true);
        }
    }, [selectedChat]);

    if (isMobile && !viewList) {
        return null;
    }

    return (
        <>
            <Stack
                minWidth={isMobile ? '100%' : 228}
                minHeight={0}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        py: 1,
                        borderBottom: '1px solid var(--mui-palette-divider)',
                    }}
                >
                    <ChatListSearch />
                    <GroupChatCreateModal createMode={true} />
                </Box>
                <Box
                    sx={{
                        overflowY: 'auto',
                    }}
                >
                    <Stack
                        direction='column'
                        divider={
                            <Divider
                                orientation='horizontal'
                                flexItem
                            />
                        }
                    >
                        {chats.map((chat) => (
                            <ChatListItem
                                key={chat.id}
                                chat={chat}
                            />
                        ))}
                    </Stack>
                </Box>
            </Stack>
            {!isMobile && (
                <Divider
                    orientation='vertical'
                    flexItem
                />
            )}
        </>
    );
};
